$(document).ready(function () {
  // Search Bar Script
  $('.searchBoxInput input').attr('placeholder', 'Search')
  $('.searchBoxInput input').val('')
  $('#mobileSearchInput').attr('placeholder', 'Search')
  $('#mobileSearchInput').val('')

  // Mobile dropdown flex
  $('.mobile-menu-subheader, .search-container, .mobile-menu-ticket-btn, .mobile-menu-slider, .mobile-menu-footer-links').wrapAll(`<div class="dropdown-wrap-containers"></div>`)

  $('.search-container').wrap('<div class="mobile-search-container"></div>')
  $('.search-container').after('<div class="mobile-bg"></div>')

  $('.mobile-menu-header').append(`
  <div class="triangle-container">
  <div class="triangle-shadow">
  <div class="triangle">
  </div
  </div
  ></div>
  `)

  // General Message
  $('.generalmessage').prependTo('header');

  // Feature LineUp Customized
  $('.featureLineupModule .featureLineupContainer').each(function () {
    $(this).find(".subContainer .featureLineupImage").prepend('<div class="overlay-lineup"></div>')
  })

  // Overlaping second content effect
  window.addEventListener("scroll", function () {
    let windowPosition = (window.pageYOffset * 100) / (document.body.scrollHeight - window.innerHeight)
    if (windowPosition > 5) {
      $('.animated-container').addClass('animated-container-negative-margin', 400)
      $('#first-content').addClass('animated-padding', 400)
    } else {
      $('.animated-container').removeClass('animated-container-negative-margin', 800)
      $('#first-content').removeClass('animated-padding', 400)
    }
  });
});

$(window).load(function () {
  // Mobile Social Clone
  $('.socialNetworks').clone().appendTo('.socialwidget-desktop')

  // Weather Script
  setInterval(function () {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (weatherBugSet || str == '') return
    $('#weatherBugWidget').addClass('weatherBugSet');
    var findSpace = str.lastIndexOf(' ');
    var stringLength = str.length;
    var res = str.substring(findSpace, stringLength);
    var start = str.substring(0, findSpace);
    $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
    $('#weatherBugWidget').css('visibility', 'visible');
  }, 12);
});


